/* NIMBUS // Cargo Kit — retro PIXEL BURST on add-to-cargo (CLAUDE.md §10 "pixel burst").
   PURELY ADDITIVE feedback: a single document-level delegated click listener on the shared
   .nb-cargobtn add button spawns a short blocky burst of accent-coloured squares from the
   cursor. It NEVER touches the add / renderContents / drawer-open flow (product-form.js owns
   that) — no preventDefault, no interference. Delegation (not per-card wiring) means it also
   covers the future product page, quick-view, and sticky bar — anywhere .nb-cargobtn renders.

   - INSTANT: fires optimistically on click at the pointer (zero perceptible lag). Adds almost
     never fail; sold-out buttons are inert (disabled) so they can't trigger it, and we guard
     .is-soldout / [disabled] / aria-disabled anyway. Never fires on a sold-out button.
   - Colour = --nb-acc (a literal hex per OS mode) so it remaps across all 6 modes for free.
   - NO glow (blocky squares only) — honours the shell's no-glow-in-retro rule everywhere.
   - Fixed overlay canvas at z-index:90 (above cards + CRT/HOLO grain@80, BELOW the drawer@100),
     pointer-events:none → never blocks or delays the drawer. No layout shift.
   - Short (~400-700ms). Canvas is created on the first burst and REMOVED once the last particle
     dies → zero lingering nodes when idle; particles live only in a JS array that empties out.
   - prefers-reduced-motion → disabled. Rapid clicks are capped (MAX) so they can't pile up. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  var canvas = null, ctx = null, W = 0, H = 0, dpr = 1;
  var parts = [];          // live particles (plain objects; no DOM nodes)
  var raf = 0;             // running requestAnimationFrame id (0 = idle)
  var last = 0;
  var MAX = 240;           // hard cap: rapid clicks can't pile up unbounded

  function createCanvas() {
    canvas = document.createElement('canvas');
    canvas.id = 'nb-cargo-burst';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;z-index:90;pointer-events:none';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth; H = window.innerHeight;
    canvas.width = Math.floor(W * dpr);
    canvas.height = Math.floor(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.imageSmoothingEnabled = false;   // crisp blocky pixels
  }

  function destroyCanvas() {
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    canvas = null; ctx = null;
  }

  function accent() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--nb-acc');
    v = (v || '').trim();
    return v || '#6fff26';
  }

  function spawn(x, y) {
    if (!canvas) createCanvas();
    var color = accent();
    for (var i = 0; i < 26 && parts.length < MAX; i++) {
      var a = Math.random() * Math.PI * 2;
      var sp = 1.6 + Math.random() * 3.8;
      parts.push({
        x: x, y: y,
        vx: Math.cos(a) * sp,
        vy: Math.sin(a) * sp - 1.4,           // slight upward kick; gravity pulls it back
        life: 1,
        decay: 0.026 + Math.random() * 0.02,  // ~370-640ms lifetimes
        size: (Math.random() < 0.5 ? 3 : (Math.random() < 0.7 ? 4 : 6)),
        color: color
      });
    }
    if (!raf) { last = 0; raf = requestAnimationFrame(tick); }
  }

  function tick(now) {
    if (!last) last = now;
    var dt = Math.min((now - last) / 16.67, 2);   // frame-normalised; clamp after tab-return
    last = now;
    ctx.clearRect(0, 0, W, H);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.vy += 0.18 * dt;                 // gravity → particles fall
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.vx *= Math.pow(0.92, dt);        // horizontal drag
      p.life -= p.decay * dt;
      if (p.life <= 0) { parts.splice(i, 1); continue; }
      ctx.globalAlpha = p.life < 0.4 ? p.life / 0.4 : 1;               // fade the tail
      ctx.fillStyle = p.color;
      ctx.fillRect(Math.floor(p.x), Math.floor(p.y), p.size, p.size);  // integer = crisp squares
    }
    ctx.globalAlpha = 1;
    if (parts.length) {
      raf = requestAnimationFrame(tick);
    } else {
      raf = 0;
      destroyCanvas();                   // no lingering nodes once idle
    }
  }

  // Delegated add-to-cargo hook — optimistic at click for instant feel. Excludes inert
  // (sold-out / disabled) buttons. Keyboard-activated clicks carry no pointer coords
  // (detail === 0) → fall back to the button's centre.
  document.addEventListener('click', function (e) {
    if (reduce && reduce.matches) return;
    var btn = e.target.closest && e.target.closest('.nb-cargobtn');
    if (!btn) return;
    if (btn.classList.contains('is-soldout') || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var x = e.clientX, y = e.clientY;
    if (e.detail === 0 || (!x && !y)) {
      var r = btn.getBoundingClientRect();
      x = r.left + r.width / 2; y = r.top + r.height / 2;
    }
    spawn(x, y);
  }, false);
})();
